import React from 'react';
import pluralize from 'pluralize';

const renderBool = fieldName => value => {
  const statement = value ? '' : <b> not </b>;

  return (
    <span>
      Plan is {statement} {fieldName}
    </span>
  );
};

const renderPrice = v => `£${v.toFixed(2)}`;
const renderQuantity = label => n => `${n} ${pluralize(label, n)}`;

export const FIELDS = [
  {
    id: 'paymentMonthly',
    title: 'Payment monthly',
    render: renderPrice,
  },
  {
    id: 'paymentPlanDiff',
    title: 'Payment plan diff',
    render: renderPrice,
  },
  {
    id: 'paymentSum',
    title: 'Payment sum',
    render: renderPrice,
  },
  {
    id: 'paymentSumPerMonth',
    title: 'Payment sum per month',
    render: renderPrice,
  },
  {
    id: 'cashBalance',
    title: 'Cash Balance',
    render: renderPrice,
  },
  {
    id: 'fullComponentsPrice',
    title: 'Full Components price',
    render: renderPrice,
  },
  {
    id: 'claimsPending',
    title: 'Claims Pending',
    render: renderPrice,
  },
  {
    id: 'customerPriceIncVAT',
    title: 'Customer price',
    render: renderPrice,
  },
  {
    id: 'customerPriceExcVAT',
    title: 'Customer price (no VAT)',
    render: renderPrice,
  },
  {
    id: 'cancelledFailedGc',
    title: 'Cancelled/Failed GC',
    render: renderPrice,
  },
  {
    id: 'paymentMonths',
    title: 'Payment months',
    render: renderQuantity('month'),
    column: 2,
  },
  {
    id: 'numServices',
    title: 'Services number',
    render: renderQuantity('service'),
    column: 2,
  },
  {
    id: 'packageName',
    title: 'Package',
    column: 2,
  },
  {
    id: 'active',
    title: 'Active',
    render: renderBool('active'),
    column: 3,
  },
  {
    id: 'payed',
    title: 'Payed',
    render: renderBool('payed'),
    column: 3,
  },
  {
    id: 'signed',
    title: 'Signed',
    render: renderBool('signed'),
    column: 3,
  },
];
